module.exports = __webpack_public_path__ + "img/otsumami.0c1395bc.jpg";